import configuration from './configurationAPI';
import auth from './authAPI';
import locations from './locationsAPI';
import measurements from './measurementsAPI';
import samplingLogs from './samplingLogsAPI';
import thresholds from './thresholdsAPI';
import keycloak from './keycloakAPI';
import alarm from './alarmAPI';
import alarmProfiles from './alarmProfilesAPI';
import mail from './mailAPI'
import poi from './poiAPI';
import alarms from './alarmsAPI';
import albums from './albumsAPI';
import notes from './notesAPI';
import reports from './reportAPI';
import incidentReports from './incidentReportsAPI';

const API = {
    configuration,
    auth,
    locations,
    measurements,
    samplingLogs,
    thresholds,
    keycloak,
    alarm,
    alarmProfiles,
    mail,
    poi,
    notes,
    alarms,
    albums,
    reports,
    incidentReports,
}

export default API;
